import React from "react";

import suitedBoy from "../../assets/img/steps/candidate/suited-boy.png";
import suitedGirl from "../../assets/img/steps/candidate/suited-girl.png";
import packagesLogo from "../../assets/img/brand/packages-logo.png";
import {Button} from "reactstrap";

const Completed = ({eventData}) => {

    const redirectToGame = () => {
        window.open(eventData.gameLink, "_blank");
    }

    return (
        <div className="d-flex justify-content-between">
            <div className="d-none d-lg-block">
                {/*<img src={left} alt="" />*/}
                <img src={suitedBoy} alt=""/>
            </div>
            {/*<Container className="m-auto">*/}
            <div className="text-center px-lg-5 mt-lg-5 pt-lg-5">
                <h3 className="main-heading">Thank you!</h3>
                <div>
                    {/*<p className="details-p">Thank you for your application! Shortlisted candidates will be contacted*/}
                    {/*    via email for the next stage.</p>*/}
                    <p className="details-p">Great! We have your all initial information now lets dive down into
                        thrilling game experience to test your skill.</p>
                    {/*<p className="details-p">Follow below game link to proceed.</p>*/}
                    {/*<a href={eventData.gameLink}>{eventData.gameLink}</a>*/}
                    <Button
                        className="gameBtn"
                        color=""
                        onClick={redirectToGame}
                    >
                        <span className="text-white font-weight-normal">Access Game Test</span>
                    </Button>

                    {/*<p className="details-p">Once you are shortlisted you will get Game link to go through our*/}
                    {/*    assessment.</p>*/}
                </div>
                {window.location.href.includes("packages") &&
                    <div>
                        <img src={packagesLogo} width={250}/>
                    </div>
                }
            </div>
            <div className="d-none d-lg-block">
                <img src={suitedGirl} alt=""/>
            </div>
        </div>
    );
};

export default Completed;
